<template>
  <div class="card-grid">
    <card title="Add Cards">
      <button class="btn btn-sm btn-primary" @click="addCard">Add card</button>
      <div class="mt-2">
        <draggable 
          v-model="page.cards"
          v-bind="dragOptions"
          class="draggable-grid"
          :group="{ pull: false, put: false }"
          @change="triggerUpdate++"
        >
          <div
            v-for="(card, cardIndex) in page.cards"
            :key="'card' + cardIndex"
            class="card-element"
          >
            <div class="card-element__handle">
              <div class="card-element__index">{{ cardIndex + 1 }}</div>

              <button class="btn btn-sm btn-link" @click="removeCard(cardIndex)">
                <fa class="trash red" :icon="['fal', 'times']" />
              </button>
            </div>
            <div class="card-element__input-wrapper">
              <input-asset class="mt-2" :returnid="true" v-model="card.assetId"/>
            </div>
            <div class="card-element__input-wrapper">
              <label for="">
                Sub Label
                <localised-field-indicator />
              </label>
              <input type="text" v-model="card.sublabel[activeLanguage.code]">
            </div>
            <div class="card-element__input-wrapper">
              <label for="">
                Price
                <localised-field-indicator />
              </label>
              <input type="text" v-model="card.price[activeLanguage.code]">
            </div>
            <div class="card-element__input-wrapper">
              <label for="">
                Label
                <localised-field-indicator />
              </label>
              <input type="text" v-model="card.label[activeLanguage.code]">
            </div>
            <div class="card-element__input-wrapper">
              <label for="">
                Body
                <localised-field-indicator />
              </label>
              <ck-editor
                v-model="card.body[activeLanguage.code]"
                :dir="activeLanguage.rtl ? 'rtl' : 'ltr'"
                :key="'card-body' + cardIndex + '-' + triggerUpdate"
                :id="'card-body' + cardIndex"
                :language="activeLanguage.code"
              />
            </div>
            <div class="card-element__input-wrapper">
              <label for="">
                QR Code
                <localised-field-indicator />
              </label>
              <input type="text" v-model="card.qrCode[activeLanguage.code]">
            </div>
            <div class="card-element__input-wrapper">
              <button class="btn btn-sm btn-primary" @click="addTag(card)">Add tag</button>
              <div
                v-for="(tag, tagIndex) in card.tags"
                :key="tag"
                class="tag-element"
              >
                <div class="card-element__input-wrapper">
                  <div class="card-element__tag-row">
                    <input type="text" :value="tag" @input="editTag($event, tag, cardIndex, tagIndex)">
                    <button class="btn btn-sm btn-link" @click="removeTag(cardIndex, tagIndex)">
                      <fa class="trash red" :icon="['fal', 'times']" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </card>
  </div>
</template>

<script>
import CkEditor from '@/components/CKEditor'
import { mapGetters } from 'vuex'
import InfoBox from '@/components/InfoBox'
import InputAsset from '@/components/InputAsset'
import draggable from 'vuedraggable';
import _ from 'lodash'

export default {
  name: 'card-display',

  components: { InfoBox, InputAsset, draggable, CkEditor },

  data () {
    return {
      triggerUpdate: 0
    }
  },

  computed: {
    ...mapGetters([
      'activeLanguage',
      'page'
    ]),

    dragOptions () {
      return {
        animation: 120,
        group: "page-cards",
        disabled: false,
        ghostClass: "ghostly",
        handle: ".card-element__handle"
      }
    },
  },

  methods: {
    addCard () {
      const newCard = {
        label: { en: '' },
        sublabel: { en: '' },
        qrCode: { en: '' },
        body: { en: '' },
        price: { en: '' },
        tags: []
      }

      this.page.cards.push(newCard)
    },

    removeCard (cardIndex) {
      this.page.cards.splice(cardIndex, 1)
      
    },

    addTag (card) {
      card.tags.push('new tag')
    },

    editTag (e, tag, cardIndex, tagIndex) {
      this.page.cards[cardIndex].tags[tagIndex] = e.target.value
    },

    removeTag (cardIndex, tagIndex) {
      this.page.cards[cardIndex].tags.splice(tagIndex, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@/styles/_mixins.scss';

.card-grid {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.draggable-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 6px;

  @media screen and (min-width: 700px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (min-width: 1420px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.card-element {
  background: rgb(229, 232, 235);
  border-radius: 4px;
  padding: 4px 8px;
  position: relative;
  margin-bottom: 6px;

  &__handle {
    align-items: center;
    cursor: grab;
    display: flex;
    justify-content: space-between;

    .trash {
      cursor: pointer;
      z-index: 1;
    }
  }

  &__index {
    align-items: center;
    background: #fff;
    border: 1px solid rgb(190, 194, 200);
    border-radius: 50%;
    display: flex;
    font-size: 11px;
    font-weight: 700;
    height: 20px;
    justify-content: center;
    margin: 6px 0 0;
    width: 20px;
  }

  &__input-wrapper {
    align-items: center;
    display: grid;

    button {
      margin: 4px auto 4px 0;
    }

    label {
      flex-shrink: 0;
      margin: auto 0;
    }

    input {
      width: 100%;
    }
  }

  &__tag-row {
    align-items: center;
    display: flex;
  }
}

</style>
